import { usePrivy } from '@privy-io/react-auth';
import GetStarted from './components/GetStarted';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import MostPopular from './components/MostPopular';
import UsageIdeas from './components/UsageIdeas';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import PhysicalGiftCards from './components/PhysicalGiftCards';
import CryptoGotReal from './components/CryptoGotReal';
import PartnersScroll from '../Pricing/Scroll';
import YoutubeVideo from '../Physical/components/YoutubeVideo';
import styled from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../common/responsive';
import UsersReview from './components/UsersReview';

const TruestedByContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 60px;
  padding-bottom: 30px;
  gap: 60px;
  @media ${PHONE_MEDIA_QUERY} {
    padding-bottom: 0px;
  }
`;

const LandingV2 = () => {
  const { user } = usePrivy();

  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/app/home');
    }
  }, [user]);

  // Handle hash-based scrolling
  useEffect(() => {
    const handleHashScroll = () => {
      const hash = window.location.hash;
      if (hash) {
        // Add a small delay to ensure DOM is fully rendered
        setTimeout(() => {
          const element = document.querySelector(hash);
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }, 100);
      }
    };

    // Handle initial hash on page load
    handleHashScroll();

    // Handle hash changes (e.g., when user clicks a link with hash)
    window.addEventListener('hashchange', handleHashScroll);

    return () => {
      window.removeEventListener('hashchange', handleHashScroll);
    };
  }, []);

  return (
    <div>
      <Hero />
      <TruestedByContainer>
        <PartnersScroll />
      </TruestedByContainer>
      <YoutubeVideo />
      <MostPopular />
      <UsersReview />
      <CryptoGotReal />
      <HowItWorks />
      <GetStarted />
    </div>
  );
};

export default LandingV2;
